import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import { blogPosts, excerptFor, formatPostDate } from '../lib/content.js';

const DEFAULT_THUMB = '/images/default_trail_header-heading.jpg';

/** Blog archive (page-blog.php). */
export default function BlogListPage() {
  const posts = blogPosts.slice(0, 10);

  return (
    <>
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="row archive-header">
          <div className="col-2"></div>
          <div className="col-8 archive-header-text">Blog</div>
          <div className="col-2"></div>
        </div>
        <div className="row archive-body">
          <div className="col-1"></div>
          <div className="col-10 archive-content">
            {posts.map((post) => (
              <div className="row" key={post.slug}>
                <div className="col blog-post-div border-red">
                  <div className="row">
                    <div className="col-3 image-center">
                      <Link to={`/blog/${post.slug}`}>
                        <img
                          className="img-fluid border-red"
                          src={post.thumbnail || DEFAULT_THUMB}
                          alt={post.title}
                        />
                      </Link>
                    </div>
                    <div className="col-9">
                      <div className="row">
                        <div className="col blog-excerpt-title">
                          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col blog-excerpt-text">{excerptFor(post)}</div>
                      </div>
                      <div className="row">
                        <div className="col-6 blog-excerpt-text">
                          <u>
                            <Link to={`/blog/${post.slug}`}>Read More</Link>
                          </u>
                        </div>
                        <div className="col-6 blog-excerpt-text blog-date-row">
                          <div className="blog-date border-red">{formatPostDate(post.date)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-1"></div>
        </div>
      </div>
      <Footer />
    </>
  );
}
